import { FC } from "react";

import { IModalProps } from "config/init/providers/ModalsProvider";
import { Layout } from "modules";
import { useTranslation } from "modules/hooks/useTranslation";

const UnderwritingWaitTimeModal: FC<IModalProps> = ({ closeModal }) => {
  const { t } = useTranslation();

  const content = {
    dataTestId: "underwriting-wait-time__modal",
    header: t("underwriting-wait-time.modal.title", "Just a moment!"),
    subheader: t(
      "underwriting-wait-time.modal.body",
      "The average time to get you a quote is around 4 minutes, but it often takes less time.\nWe’re moving things along in the background to get your quote finalized. Hang tight, you’re almost there!"
    ),
    onClose: closeModal,
    button: {
      text: t("underwriting-wait-time.modal.cta", "CLOSE"),
      subType: "primary",
      onClick: closeModal,
    },
    icon: "BlobTime",
  };

  return <Layout as="ModalLayout" content={content} className="left-align" />;
};

export default UnderwritingWaitTimeModal;
